module.exports = __webpack_public_path__ + "fd5a608a/img/37000000-8.5c6c3349.png";